export default __webpack_public_path__ + "static/media/boots_of_the_farseeker.e62e7d3c.jpg";